export default __webpack_public_path__ + "static/media/04.13b9703a.jpg";